import Vue from 'vue';
import App from './App.vue';
import router from './router';

// Global 3rd party plugins
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import './assets/css/styles.css';

import jquery from 'jquery';
window.$ = jquery;

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');

document.addEventListener('DOMContentLoaded', function () {
  // Reset OneTrust button text to MCS sentence style
  const wait = {
    '1': 500,
    '2': 1000,
    '3': 3000,
  }
  let tries = 0;

  function resetOTFooterText() {
    tries += 1
    if (tries >= 3) return

    const btn = document.getElementById('ot-sdk-btn')
    btn && (btn.textContent = 'Cookie preferences')

    setTimeout(resetOTFooterText, wait[tries]);
  }

  window.addEventListener('load', resetOTFooterText)
});

